module.exports = __webpack_public_path__ + "static/QatarTeam-442c6d7d471ade8a1f9e089114654c46.jpeg";